import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { LayoutCenter, LayoutCluster } from 'design-system/server';
import Link from 'next/link';
import { Routes } from '@/helpers/utils';
import Image from 'next/image';
import { useLocale, useTranslations } from 'next-intl';
import styles from './FundraisingEventTeamList.module.css';
import type { FundraisingEventTeamListProps, FundraisingEventTeamMemberProps } from './types';
import ButtonLink from '@/components/ButtonLink';
import getOrderedEvents from './helpers/getOrderedEvents';
export function FundraisingEventTeamMemberImage(t0) {
  const $ = _c(20);
  let id;
  let image;
  let index;
  let label;
  let props;
  if ($[0] !== t0) {
    const {
      id: t1,
      image: t2,
      isMainEvent,
      label: t3,
      index: t4,
      ...t5
    } = t0;
    id = t1;
    image = t2;
    label = t3;
    index = t4;
    props = t5;
    $[0] = t0;
    $[1] = id;
    $[2] = image;
    $[3] = index;
    $[4] = label;
    $[5] = props;
  } else {
    id = $[1];
    image = $[2];
    index = $[3];
    label = $[4];
    props = $[5];
  }
  const locale = useLocale();
  let t1;
  if ($[6] !== id || $[7] !== locale) {
    t1 = Routes.fundraisingEvents({
      locale,
      slug: id
    });
    $[6] = id;
    $[7] = locale;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.imgContainer, styles.link);
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== index) {
    t3 = {
      "--index": index
    };
    $[10] = index;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = t3 as CSSProperties;
  let t5;
  if ($[12] !== image) {
    t5 = <Image alt="" src={image} className={styles.image} fill={true} />;
    $[12] = image;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== label || $[15] !== props || $[16] !== t1 || $[17] !== t4 || $[18] !== t5) {
    t6 = <Link href={t1} className={t2} style={t4} aria-label={label} prefetch={false} {...props}>{t5}</Link>;
    $[14] = label;
    $[15] = props;
    $[16] = t1;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
const MAX_VISIBLE_TEAM_MEMBERS = 4;
const THIN_WHITE_SPACE = ' ';
function FundraisingEventTeamList(t0) {
  const $ = _c(29);
  const {
    mainEvent,
    supportingEvents,
    id: currentEventId
  } = t0;
  const t = useTranslations("nextjs.receiver_pages.fundraising_event.team_section");
  const locale = useLocale();
  let T0;
  let T1;
  let showMoreAmount;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== currentEventId || $[1] !== mainEvent || $[2] !== supportingEvents) {
    const {
      orderedEvents,
      teamSize,
      showMoreAmount: t7
    } = getOrderedEvents({
      mainEvent,
      supportingEvents,
      id: currentEventId,
      maxVisible: MAX_VISIBLE_TEAM_MEMBERS
    });
    showMoreAmount = t7;
    T1 = LayoutCenter;
    t5 = styles.container;
    t6 = "section";
    T0 = LayoutCluster;
    t1 = "none";
    t2 = styles.listContainer;
    t3 = {
      "--nr-of-items": teamSize
    } as CSSProperties;
    t4 = orderedEvents.map(_temp);
    $[0] = currentEventId;
    $[1] = mainEvent;
    $[2] = supportingEvents;
    $[3] = T0;
    $[4] = T1;
    $[5] = showMoreAmount;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[3];
    T1 = $[4];
    showMoreAmount = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== currentEventId || $[13] !== locale || $[14] !== showMoreAmount || $[15] !== t) {
    t7 = showMoreAmount > 0 && <ButtonLink kind="secondary-circular" className={styles.button} aria-label={t("show_more_button_label")} href={Routes.fundraisingEventsTeamMembers({
      locale,
      slug: currentEventId
    })}>{`+${THIN_WHITE_SPACE}${showMoreAmount}`}</ButtonLink>;
    $[12] = currentEventId;
    $[13] = locale;
    $[14] = showMoreAmount;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== T0 || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t7) {
    t8 = <T0 space={t1} className={t2} style={t3}>{t4}{t7}</T0>;
    $[17] = T0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== T1 || $[25] !== t5 || $[26] !== t6 || $[27] !== t8) {
    t9 = <T1 className={t5} as={t6}>{t8}</T1>;
    $[24] = T1;
    $[25] = t5;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp(event, index) {
  return <FundraisingEventTeamMemberImage key={event.id} id={event.id} image={event.publicFace.imageUrl400x400} isMainEvent={event.isMainEvent} label={event.name} index={index} />;
}
export default FundraisingEventTeamList;